import Button, { TextButton } from "./Button";
import Footer from "./Footer/FooterUI";
import DevPreFooter from "./Footer/DevPreFooter";
import Header from "./Header/HeaderUI";
import SideNav from "./SideNav/UI/SideNavUI";
import Dropdown from "./Dropdown";
import Tabs from "./Tabs/Tabs";
import TabPanel from "./Tabs/TabPanel";
import Infotip from "./Infotip";
import {
  MyApplicationsIcon,
  UserSignInIcon,
  MyTestDataIcon,
  ReportDataIcon,
  ManageUsersIcon,
  AccountHomeIcon,
  FacilityBasedPreviewIcon,
  PaymentIcon,
  PhysicianCompareIcon,
  HardshipIcon,
  TargetIcon,
  ReportsIcon,
  HelpSupportIcon,
  DashboardIcon,
  AccountSettings,
  DetailsIcon,
  DownloadIcon2,
  StarIcon,
  RegistrationIcon,
  CliniciansIcon,
  GroupReporting,
  IndividualReporting,
  ChevronLeft,
  ChevronRight,
  ChevronDown,
  SwitchPractice,
  ScoreIncrease,
  TooltipIcon,
  NavCollapse,
  NavExpand,
  CloseXIcon,
  CloseXIcon2,
  BellOutline,
  EarlyClaims,
  CliniciansList,
  YoutubeIcon,
  TwitterIcon,
  WiViewReportsIcon,
  WiViewProgressIcon,
  WiManageGroupIcon,
} from "../lib/SvgComponents.jsx";

const Icons = {
  MyApplicationsIcon,
  UserSignInIcon,
  MyTestDataIcon,
  ReportDataIcon,
  ManageUsersIcon,
  AccountHomeIcon,
  FacilityBasedPreviewIcon,
  PaymentIcon,
  PhysicianCompareIcon,
  HardshipIcon,
  TargetIcon,
  ReportsIcon,
  HelpSupportIcon,
  DashboardIcon,
  AccountSettings,
  DetailsIcon,
  DownloadIcon2,
  StarIcon,
  RegistrationIcon,
  CliniciansIcon,
  GroupReporting,
  IndividualReporting,
  ChevronLeft,
  ChevronRight,
  ChevronDown,
  SwitchPractice,
  ScoreIncrease,
  TooltipIcon,
  NavCollapse,
  NavExpand,
  CloseXIcon,
  CloseXIcon2,
  BellOutline,
  EarlyClaims,
  CliniciansList,
  YoutubeIcon,
  TwitterIcon,
  WiViewReportsIcon,
  WiViewProgressIcon,
  WiManageGroupIcon,
};

export {
  Button,
  Dropdown,
  Footer,
  DevPreFooter,
  Header,
  Icons,
  Infotip,
  SideNav,
  TextButton,
  Tabs,
  TabPanel,
};
